import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import MerchantAppShell from "./merchant-shell/MerchantAppShell";
import { useAuth } from "../../features/auth/context/AuthContext";
import SupportModeLayout from "../../features/auth/components/SupportModeLayout";

/* Editoren und der Batch-Wizard ersetzen die Sidebar durch ihre eigene
   Kontext-Navigation (Design „Nachtschicht": Vollbild ohne Hauptnav —
   Screens 5a/9c, Wizard 4b). Alle drei Flächen haben eigene Zurück-Wege. */
const FULLSCREEN_PATTERNS = [
  /^\/templates\/[^/]+$/, // Template-Editor
  /^\/design-generator\/edit\//, // Design-Editor
  /^\/articles\/new$/, // Batch-Wizard (eigene Stepper-Rail)
];

function isFullscreenRoute(pathname) {
  return FULLSCREEN_PATTERNS.some((re) => re.test(pathname));
}

/**
 * Layout shell for authenticated pages.
 * Desktop: Sidebar (left, sticky, trägt Logo/Sprache/Nutzermenü) + Content.
 * Mobile:  AuthHeader (schlanke Topbar) + Content + MobileNav (bottom, fixed).
 * Editor-Routen: Vollbild ohne Shell-Chrome.
 */
export default function AuthenticatedLayout() {
  const location = useLocation();
  const { supportSession } = useAuth();
  const fullscreen = isFullscreenRoute(location.pathname);
  if (supportSession) return <SupportModeLayout />;

  if (fullscreen) {
    return (
      <div className="min-h-screen bg-background text-on-surface font-sans antialiased">
        <Outlet />
      </div>
    );
  }

  return <MerchantAppShell />;
}
